import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { z } from 'zod';
import type { ProductClaim } from '../types/product-claim.type';

export const UpdateProductClaimSchema = z.object({
  product_id: z.string().min(1, {
    message: 'Produk tidak boleh kosong!',
  }),
  code: z.string().min(1, {
    message: 'Kode tidak boleh kosong!',
  }),
  name: z.string().min(1, {
    message: 'Judul tidak boleh kosong!',
  }),
  max_quota: z.number({ message: 'Kuota harus berupa angka!' }),
  allow_mode: z.enum(['WHITELIST', 'BLACKLIST'], {
    message: 'Mode tidak valid!',
  }),
  is_active: z.boolean(),
  starts_at: z.string().min(1, {
    message: 'Tanggal mulai tidak boleh kosong!',
  }),
  expired_at: z.string().min(1, {
    message: 'Tanggal kadaluarsa tidak boleh kosong!',
  }),
});
export type UpdateProductClaimData = z.infer<typeof UpdateProductClaimSchema>;
export type UpdateProductClaimPayload = {
  klaim_produk_id: string;
  data: UpdateProductClaimData;
};
export type UpdateProductClaimResponse = ApiResponse<ProductClaim>;

export const updateProductClaim = async (
  payload: UpdateProductClaimPayload
): Promise<UpdateProductClaimResponse> => {
  const { klaim_produk_id, data } = payload;
  const url = `product-promotion/${klaim_produk_id}`;

  return await apiClient.patch(url, data);
};

export function updateProductClaimMutationOptions() {
  return mutationOptions<
    UpdateProductClaimResponse,
    AxiosError,
    UpdateProductClaimPayload
  >({
    mutationFn: updateProductClaim,
  });
}
